import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input
} from "reactstrap";
import toast from "react-hot-toast";

const ManageOutward = ({ orderId }) => {
  const baseurl = process.env.REACT_APP_BASE_URL;
  const user = JSON.parse(localStorage.getItem("authUser"));

  const [outwardItems, setOutwardItems] = useState([]);
  const [outwardModal, setOutwardModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [outwardQty, setOutwardQty] = useState("");

  const [historyData, setHistoryData] = useState([]);
  const [showHistoryModal, setShowHistoryModal] = useState(false);

  useEffect(() => {
    if (orderId) {
      fetchOutwardDetails();
    }
  }, [orderId]);

  // 🔹 Fetch outward list
  const fetchOutwardDetails = async () => {
    try {
      const res = await fetch(
        `${baseurl}/admin/customer/outward-details/${orderId}`
      );
      const data = await res.json();
      setOutwardItems(data || []);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 View Transfer History
  const handleViewTransferHistory = async (orderItemId) => {
    try {
      const res = await fetch(
        `${baseurl}/admin/customer/transfer-history/${orderItemId}`
      );
      const data = await res.json();
      setHistoryData(data || []);
      setShowHistoryModal(true);
    } catch (err) {
      console.error(err);
    }
  };

  // 🔹 Open outward modal
  const handleCreateOutward = (item) => {
    setSelectedItem(item);
    setOutwardQty("");
    setOutwardModal(true);
  };

  // 🔹 Save outward
  const handleSaveOutward = async () => {
    if (!outwardQty || outwardQty <= 0) {
      toast.error("Invalid quantity");
      return;
    }

    if (parseInt(outwardQty) > selectedItem.balance_qty) {
      toast.error("Outward qty cannot exceed balance qty");
      return;
    }

    try {
      const res = await fetch(
        `${baseurl}/admin/customer/create-outward`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            order_id: orderId,
            order_item_id: selectedItem.order_item_id,
            product_id: selectedItem.product_id,
            quantity: parseInt(outwardQty),
            user_id: user?.id
          })
        }
      );

      const data = await res.json();

      if (data.success) {
        toast.success("Outward Created Successfully");
        setOutwardModal(false);
        setSelectedItem(null);
        setOutwardQty("");
        fetchOutwardDetails();
      } else {
        toast.error(data.message || "Something went wrong");
      }

    } catch (err) {
      console.error(err);
      toast.error("Server Error");
    }
  };

  return (
    <>
      <Card>
        <CardBody>
          <h5 className="mb-3">Manage Outward</h5>

          <div className="table-responsive">
            <Table bordered>
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Ordered</th>
                  <th>Outward</th>
                  <th>Invoiced</th>
                  <th>Balance</th>
                  <th>Online</th>
                  <th>Offline</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {outwardItems.length > 0 ? (
                  outwardItems.map((item, index) => (
                    <tr key={item.order_item_id}>
                      <td>{index + 1}</td>
                      <td>{item.product_name}</td>
                      <td>{item.ordered_qty}</td>
                      <td>{item.outward_qty}</td>
                      <td>{item.invoiced_qty}</td>
                      <td>
                        <strong className="text-danger">
                          {item.balance_qty}
                        </strong>
                      </td>
                      <td>{item.online_stock}</td>
                      <td>{item.offline_stock}</td>

                      <td className="d-flex gap-2">
                        {item.balance_qty > 0 && (
                          <Button
                            color="success"
                            size="sm"
                            onClick={() => handleCreateOutward(item)}
                          >
                            <i className="bx bx-send"></i>
                          </Button>
                        )}

                        <Button
                          color="info"
                          size="sm"
                          onClick={() =>
                            handleViewTransferHistory(item.order_item_id)
                          }
                        >
                          <i className="bx bx-transfer"></i>
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      No Outward Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>

      {/* 🔹 Outward Modal */}
      <Modal isOpen={outwardModal} toggle={() => setOutwardModal(false)}>
        <ModalHeader toggle={() => setOutwardModal(false)}>
          Create Outward
        </ModalHeader>

        <ModalBody>
          {selectedItem && (
            <>
              <div className="mb-3">
                <label>Product</label>
                <Input value={selectedItem.product_name} disabled />
              </div>

              <div className="mb-3">
                <label>Balance Qty</label>
                <Input value={selectedItem.balance_qty} disabled />
              </div>

              <div className="mb-3">
                <label>Outward Qty</label>
                <Input
                  type="number"
                  min="1"
                  max={selectedItem.balance_qty}
                  value={outwardQty}
                  onChange={(e) => setOutwardQty(e.target.value)}
                />
              </div>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setOutwardModal(false)}
          >
            Cancel
          </Button>

          <Button
            color="success"
            onClick={handleSaveOutward}
            disabled={!outwardQty}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>

      {/* 🔹 Transfer History Modal */}
      <Modal
        isOpen={showHistoryModal}
        toggle={() => setShowHistoryModal(false)}
        size="lg"
      >
        <ModalHeader toggle={() => setShowHistoryModal(false)}>
          Transfer History
        </ModalHeader>

        <ModalBody>
          <Table bordered>
            <thead>
              <tr>
                <th>Transfer Mode</th>
                <th>Qty</th>
                <th>Transferred By</th>
                <th>Date</th>
              </tr>
            </thead>

            <tbody>
              {historyData.length > 0 ? (
                historyData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.transfer_mode}</td>
                    <td>{row.transferred_qty}</td>
                    <td>{row.transfer_via}</td>
                    <td>{row.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Transfer History Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </>
  );
};

export default ManageOutward;
